import { render, staticRenderFns } from "./FormEditReceive.vue?vue&type=template&id=6d486093"
import script from "./FormEditReceive.vue?vue&type=script&lang=js"
export * from "./FormEditReceive.vue?vue&type=script&lang=js"
import style0 from "./FormEditReceive.vue?vue&type=style&index=0&id=6d486093&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports